import { HiOutlineInformationCircle } from "react-icons/hi";

export function TableHeaderWithTooltip({ label, tooltip }) {
  if (!tooltip) return <span>{label}</span>;

  return (
    <div className="inline-flex items-center gap-1 relative">
      <span className="font-semibold">{label}</span>
      <div className="group relative flex items-center">
        <HiOutlineInformationCircle className="w-4 h-4 text-gray-500 cursor-help" />
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 min-w-[200px] max-w-sm bg-gray-900 text-white text-sm rounded px-3 py-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 break-words">
          {tooltip}
        </div>
      </div>
    </div>
  );
}